// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"a2e1a33f","141":"a1eb673b","235":"0e866ef7","251":"b05b1349","395":"7b655f36","453":"a255cb81","522":"3d4986eb","671":"80b0b993","683":"84c65bcd","731":"95f5352b","810":"0c6b2cb5","827":"4d2ada70","885":"11b187d7"}[chunkId] + ".chunk.js";
};